/* global CONTENT, CONTENT_TARGET, ga, runningMode */

/**
 * This object generate event listeners.
 * Should only be called from CONTENT_TARGETS.
 * @type Object
 */
var Events = {
  /**
   * Generates event handler for content object.
   * @param {object} contentObject
   * @returns {undefined}
   */
  generate: function (contentObject) {
    //set event listener to content node, so events do not have to be unbinded manualy
    var contentWrapper = document.querySelector("main.mdl-layout__content")
      .children[0];

    var events = contentObject.events;

    //group events by event type
    var eventMap = {};
    for (var i = 0, len = events.length; i < len; i++) {
      var event = events[i];
      if (eventMap[event.event] === undefined) eventMap[event.event] = [];

      eventMap[event.event].push(event);
    }

    //create a single event listener for each event type
    for (var i in eventMap) {
      contentWrapper.addEventListener(i, function (e) {
        //iterate trough all event objects of this type

        var events = eventMap[e.type];
        for (var i = 0, len = events.length; i < len; i++) {
          var event = events[i];

          //search for all posible targets
          var allEventTargets = contentWrapper.querySelectorAll(event.source);

          //search in e.path for the right target
          for (var j = 0, len2 = allEventTargets.length; j < len2; j++) {
            var target = allEventTargets[j];

            //safari, firefox have no event.path
            var nodeToCheck = e.target;

            //go trouth parentNodes until node to check is the element with the event handler is bind to
            while (nodeToCheck !== contentWrapper && nodeToCheck !== null) {
              if (nodeToCheck === target) {
                //call event function with context of target
                event.function.call(target, e);
                return;
              }
              nodeToCheck = nodeToCheck.parentNode;
            }
          }
        }
      });
    }
  },
  /**
   * Generates an event listener wich can be used to affect on future elements.
   * On event the function will search for a target defined by a selector.
   * Note: if the listener already exists, a second will be bind.
   * @param {Element} parent
   * The listener will be bind to this node. If this node will be deleted, the
   * listener will also disappear. You should use the closest possible parent element.
   * @param {String} selector
   * CSS selector relative to <i>parent</i>.
   * @param {String} eventType
   * Native JavaScript event type.
   * @param {Function} handler
   * Function should to be called on event. You can use the statemant <i>this</i>
   * wich would be the target node found from <i>selector</i>
   * @returns {undefined}
   */
  bind: function (parent, selector, eventType, handler) {
    //Add listener to parent
    parent.addEventListener(eventType, function (e) {
      //search for all posible targets
      var allEventTargets = this.querySelectorAll(selector);

      //search in e.path for the right target
      for (var i = 0, len = allEventTargets.length; i < len; i++) {
        var target = allEventTargets[i];

        //safari, firefox have no event.path
        var nodeToCheck = e.target;

        //go trouth parentNodes until node to check is the element with the event handler is bind to
        while (nodeToCheck !== parent) {
          if (nodeToCheck === target) {
            //call event function with context of target
            handler.call(target, e);
            return;
          }
          nodeToCheck = nodeToCheck.parentNode;
        }
      }
    });
  },
};

/**
 * Uses the History API to manage changing the viewes with browser buttons.
 * @type object
 */
var urlHistory = {
  /**
   * This function should be called to initialize the urlHistory listener.
   * @returns {Promise}
   */
  init: function () {
    return new Promise((resolve, reject) => {
      //start listener
      window.onpopstate = function (e) {
        if (urlHistory._popState) {
          urlHistory._popState = false;
          return;
        }

        urlHistory.changeViewByURL({
          //do not push new url state
          //if you do, the new state will remove the ability to go forward
          disableUrlPushState: true,
        });
      };

      resolve();
    });
  },
  /**
   * Inspect <i>window.location.search</i> for view name and refer to that.
   * Uses all url parameter for view change.
   * @param {object} options
   * Options for <i>CONTENT_TARGETS.PAGE.changecontent()</i>
   * @returns {undefined}
   */
  changeViewByURL: function (options) {
    var view = null;

    //get view name and data from URL
    var urlData = URIToObject(window.location.search);
    if (urlData.view !== undefined) {
      var allContent = getAllContentFromObject(CONTENT);

      //search for view by css_id
      for (var i in allContent) {
        var viewTmp = allContent[i];
        if (viewTmp.css_id === urlData.view) {
          view = viewTmp;
          break;
        }
      }
    }

    //if no view found, take the default from runningMode
    if (view === null) view = runningMode.mode.startContent.content;

    //prepare data for view
    delete urlData.view;
    if (Object.keys(urlData).length === 0) urlData = undefined;

    //change view
    CONTENT_TARGET.changeContent(view, urlData, undefined, options);
  },
  // ---- external use start ----
  /**
   * <i>true</i> after <i>histtory.back</i> and before <i>onpopstate</i>
   * @type Boolean
   */
  _popState: false,
  pop: function () {
    urlHistory._popState = true;
    history.back();
  },
  /**
   * Pushes an object to <code>history</code> and updates the url with
   * the new params.
   * @param {object} content_object CONTENT.*
   * @param {object} data
   * Data the view from <i>objet</i> will be called on <i>init()
   * @returns {undefined}
   */
  push: function (content_object, data) {
    this._run(content_object, data, "push");
  },
  /**
   * Replace current history state with new one from <i>content_object</i>
   * @param {object} content_object CONTENT.*
   * @param {object} data
   * Data the view from <i>objet</i> will be called on <i>init()
   * @returns {undefined}
   */
  replace: function (content_object, data) {
    this._run(content_object, data, "replace");
  },
  /**
   * Performs call of <i>push</i> and <i>replace</i>
   * @param {object} content_object CONTENT.*
   * @param {object} data
   * Data the view from <i>objet</i> will be called on <i>init()
   * @param {string} action push, replace
   * @returns {undefined}
   */
  _run: function (content_object, data, action) {
    var identifier = this._generateId(content_object, data);

    //google analytics
    if (typeof ga !== "undefined") {
      ga("set", "page", window.location.pathname + "?" + identifier);
      ga("send", "pageview");
    }

    switch (action) {
      case "push":
        history.pushState(null, null, "?" + identifier);
        break;
      case "replace":
        history.replaceState(null, null, "?" + identifier);
        break;
    }
  },
  /**
   * You should implement this self. (Also the parameters) It will be used to generate an id. If you want to <code>pop()</code>
   * this function will be very helfull.
   * @param {object} object
   * Object from <i>CONTENT</i>
   * @param {object} data
   * Data the view from <i>objet</i> will be called on <i>init()</i>
   * @returns {string}
   */
  _generateId: function (object, data) {
    var str = "view=" + object.css_id + "&";
    str += objectToURI(data);

    var strlen = str.length;
    if (str.substr(strlen - 1) === "&") str = str.substr(0, strlen - 1);

    while (str.indexOf("&&") !== -1) {
      str = str.replace("&&", "&");
    }

    return str;
  },
};
